import React, { useState, useEffect } from "react";
import "./trainernotify.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { MOBILE_BREAKPOINT,HTTP_STATUS } from "../../constants/constant";
import { HiMenu, HiX } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import useMobileView from "../../constants/useMobileView";
import Cookies from 'js-cookie';
import { decode } from "base-64";

import {
  postCreateNotification,
  stateListAction,
  districtListAction,
  usergroupListAction,
  RedirectionPageListAction
} from "../../actions/notificationAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";

function TrainerNotification() {
  const [cities, setcities] = useState([]);
  const { isMobileView, isSidebarOpen, toggleSidebar } = useMobileView();

  const [newcity, setNewcity] = useState("");
  const [statelist, setStatelist] = useState([]);
  
  const [district, setDistrict] = useState([]);
  const [grouplist, setGrouplist] = useState([]);
  const [redirectionPagelist, setRedirectionPagelist] = useState([]);
  const [count, setCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [textCount, setTextCount] = useState(0);
  const [textCounts, setTextCounts] = useState(0);

  var vehicleType = Cookies.get('vehicletype') ? Cookies.get('vehicletype') : "";
  
  function updateChars(e) {
    const text = document.getElementById("text").value;
    setTextCount(text.length);
  }
  function updateCharsters(e) {
    const text = document.getElementById("text2").value;
    setTextCounts(text.length);
  }
  if (vehicleType) {
    vehicleType = decode(vehicleType)
  }
  const is3w = () => {
    return vehicleType == "3W"
  };  

  const [states, setDataStates] = useState({
    state: "",
    region: "Test",
    region_type: "District",
    title: "",
    minimum_redemption_amount:"",
    body: "",
    starting_date: "",
    starting_time: "",
    duration: "",
    group:"",
    redirection_page:""
  });

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    stateListData();
    getgroupListData();
    GetRedirectionPageListData();
  }, []);

  

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    updateChars();
    updateCharsters();
  };


  // Function to handle adding a new city
  const addcity = () => {
    if (newcity.trim() !== "" && newcity == "all") {
      setcities([...district]);
      setNewcity("");
    }
    else if (newcity.trim() !== "" && newcity !== "all") {
      const newCityObject = JSON.parse(newcity);
  
      // Check if the city with the same ID already exists
      const cityExists = cities.some((city) => city.id === newCityObject.id);
  
      if (!cityExists) {
        setcities([...cities, newCityObject]);
        setNewcity("");
      } else {
        notify.error("City already added");
        
      }
    }
  };
  

  const removecity = (index) => {
    const updatedcities = [...cities];
    updatedcities.splice(index, 1);
    setcities(updatedcities);
  };

  // Function calling For State List

  async function stateListData() {
    setIsLoading(true);
    var response = await dispatch(stateListAction());
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      setStatelist(response?.data?.results?.data);
      // setStatelist(response.data.data);
    }
  }

  // Function calling for District List based On state

  async function districtListData(state_id) {
    setIsLoading(true);
    var response = await dispatch(districtListAction(state_id));
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      // setDistrict(response.data.results.data);
      setDistrict(response.data.data);
    }
  }

  
  async function getgroupListData() {
    setIsLoading(true);
    var response = await dispatch(usergroupListAction());
    if (response.status === 200) {
      setIsLoading(false);
      const dataArray = Object.entries(response?.data?.data)?.map(([key, value]) => ({
        group_key: key,
        group_value: value
      }));
      setGrouplist(dataArray);
    }

  }

  async function GetRedirectionPageListData() {
    setIsLoading(true);
    var response = await dispatch(RedirectionPageListAction());
    if (response.status === 200) {
      setIsLoading(false);
      setRedirectionPagelist(response.data.data);
      if(response?.data?.data && response.data.data.length>0){
        response.data.data.map((val)=>{
          if(String(val.page_slug).toLowerCase()==="dashboard"){
            setDataStates({
              ...states,
              redirection_page: val.id,
            });
          }
        })
      }
    }

  }

  const disabledState = statelist.find((state) => state.state.toLowerCase() === "all")?.id;
  
  const handleChangeState = (evt) => {
    const state_id = evt.target.value;
    const allState = statelist.find((state) => state.state.toLowerCase() === "all");
    setDataStates({
      ...states,
      state: state_id,
    });
    if (allState && state_id === allState.id) {
      setcities([]);
  } else {
      districtListData(state_id);
  }
    setcities([]);
    districtListData(state_id);
  };
  const createNotification = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let apiReq = {
      district_ids: cities.map((data) => data.id),
      title: states.title,
      body: states.body,
      starting_date: selectedDate,
      starting_time: selectedTime,
      duration: states.duration,
      user_group: states.group,
      redirection_page: states.redirection_page,
      state_id: states.state, // Include the state ID in the request payload
      minimum_redemption_amount: states.minimum_redemption_amount,
    };
    if (!apiReq.user_group) {
      delete apiReq.user_group;
    }
    if (!apiReq.state_id) {
      delete apiReq.state_id;
    }
    if (states.minimum_redemption_amount === "") {
      delete apiReq.minimum_redemption_amount;
    }
    let response = await dispatch(postCreateNotification(apiReq));
    if (response == 200 || response != null) {
      notify.success("New notification has been created.");
      setIsLoading(false);
      navigate("/notification");
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };
  const handleDateChange = (event) => {
    setSelectedTime("");
    const { value } = event.target;
    setSelectedDate(value);
    if (value === getCurrentDate()) {
      setCurrentDateTime(new Date());
    } else {
      setCurrentDateTime(null);
    }
  };
  const handleTimeChange = (event) => {
    const { value } = event.target;
    if (selectedDate === getCurrentDate() && value < getCurrentTime()) {
      setSelectedTime(getCurrentTime());
    } else {
      setSelectedTime(value);
    }
  };

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };  

  return (
    <div className="trainercontainer">
      <div className="trainercontainerright">
        <Header title="Create Notification" />
        <div className="container_s">
        {isLoading ? (
            <Loader />
          ) : (
          <form>
            <div className="grid">
              <span className="label-create-notification-trainers">State</span>
              <select
                name="state"
                value={states.state}
                onChange={handleChangeState}
              >
                <option value="0">Select State</option>
                {statelist?.map((item) => (
                  <option value={item.id}>{item?.state}</option>
                ))}
              </select>
            </div>
            <div className="grid">
              <span className="label-create-notification-trainers">City/District</span>
              <select
                value={newcity}
                onChange={(e) => setNewcity(e.target.value)}
                disabled={Number(states.state) === Number(disabledState)} 
                className={Number(states.state) === Number(disabledState) ? "disabled-dropdown" : ""}
              >
                <option value="">Select City/District</option>
                <option value="all">All</option>
                {district.map((list) => (
                  <option key={list.id} value={JSON.stringify(list)}>
                    {list.district}
                  </option>
                ))}
              </select>
              <img src={Image_Url.PLUS} height="40%" className={Number(states.state) === Number(disabledState) ? "disabled-dropdown" : ""} onClick={addcity}></img>
            </div>
            {cities.map((city, index) => (
              <div className="grid" key={city.id}>
                <p></p>
                <select value={city} readonly disabled={cities.length > 0}>
                  <option value={city.id}>{city.district}</option>
                </select>
                <img src={Image_Url.MINUS} onClick={() => removecity(index)} />
              </div>
            ))}
             <div className="grid">
              <span className="label-create-notification-trainers">Select Group</span>
              <select
                name="group"
                value={states.group}
                onChange={handleChange}
                placeholder="Select Group"
              >
                <option value="">Select Group</option>
                {grouplist.map((item)=>
                <option value={item.group_key}>{item.group_value}</option>
                )}
              </select>
            </div>
            {
              states.group !== "sufficient_balance_for_redemption" && states.group !== "low_balance_in_wallet" ?
             "" : 
              <div className="grid">
                  <label className="label-create-notification">Redemption Amount</label>
                  <textarea
                    className="heading"
                    placeholder="Redemption Amount"
                    name="minimum_redemption_amount"
                    value={states.minimum_redemption_amount}
                    onChange={handleChange}
                  ></textarea>
                  </div>
              }
            <div className="grid">
              <label className="label-create-notification">Heading</label>
              <div className="text-box-div">
              <textarea
               
                className="heading"
                placeholder="Heading"
                name="title"
                value={states.title}
                onChange={handleChange}
                maxLength={100}
                id="text2"
              ></textarea>
              <p className='textcount-notyfy-headings montserrat-font'>{textCounts}/100</p>
              </div>
            </div>
            <div className="grid">
              <label className="label-create-notification">Description</label>
              <div className="text-box-div">
              <textarea
                className="description"
                placeholder="description"
                name="body"
                value={states.body}
                maxLength={300}
                onChange={handleChange}
                id="text"
              ></textarea>
              <p className='textcount-notyfy-descriptions montserrat-font'>{textCount}/300</p>
              </div>
            </div>
            <div class="grid">
                <label className="add-notify-label">Select Redirection Page</label>
                <select

                name="redirection_page"
                value={states.redirection_page}
                onChange={handleChange}
                >
                  <option value="">Select Redirection Page</option>
                {redirectionPagelist.map((data)=>
                <option key={data.id} value={data.id}>{data.page}</option>
                )}
                </select>
              </div>
            <div className="grid date">
              <label className="label-create-notification">Send On Date</label>
              <input
                type="date"
                name="starting_date"
                value={selectedDate}
                onChange={handleDateChange}
                min={getCurrentDate()}
              />
            </div>
            <div className="grid">
              <label className="label-create-notification">Send at Time</label>
              <input
                type="time"
                value={selectedTime}
                onChange={handleTimeChange}
                disabled={!selectedDate}
              />
            </div>
            <div className="grid">
              <label className="label-create-notification">Duration</label>
              <select
                name="duration"
                value={states.duration}
                onChange={handleChange}
              >
                <option>Select Duration</option>
                <option value="1 day">1 day</option>
                <option value="2 day">2 days</option>
                <option value="3 day">3 days</option>
                <option value="4 day">4 days</option>
                <option value="5 day">5 days</option>
                <option value="6 day">6 days</option>
                <option value="7 day">7 days</option>
                <option value="8 day">8 days</option>
                <option value="9 day">9 days</option>
                <option value="10 day">10 days</option>
                <option value="11 day">11 days</option>
                <option value="12 day">12 days</option>
                <option value="13 day">13 days</option>
                <option value="14 day">14 days</option>
                <option value="15 day">15 days</option>
              </select>
            </div>
            <div className="btn-notify">
              <button
                onClick={() => {
                  navigate("/notification");
                }}
                className="notify-active"
              >
                Close
              </button>
              <button
                onClick={createNotification}
                className="notify-active"
                disabled={
                  /* TO-DO */
                  // is3w
                  //   ? Number(states.state) === Number(disabledState)
                  //       ? !(newcity == "" || cities?.length == 0) :  cities?.length <= 0
                  //   : newcity == "" || cities?.length <= 0
                  // ||
                  
                  states.newcity === "" ||
                  states.title === "" ||
                  states.body === "" ||
                  selectedDate === "" ||
                  selectedTime === "" ||
                  states.duration === "" ||
                  states.redirection_page === "" 
                }
              >
                Send
              </button>
            </div>
          </form>
          )}
        </div>
      </div>
    </div>
  );
}
export default TrainerNotification;